import { confirm } from "lib/ConfirmationModal/ConfirmationModal";

const confirmDeleteUser = ({ onOk, onCancel }) => {
  const header = "Delete Account";
  const text = `Are you sure you want to delete your account?
                Once deleted, you won't be able to recover your account or its contents.`;
  const buttonsDetails = {
    ok: {
      theme: "redSolid",
      name: "Delete"
    },
    cancel: {
      theme: "gray"
    }
  };

  return () => {
    return confirm({
      header,
      text,
      onOk,
      onCancel,
      buttonsDetails
    });
  };
};

export default confirmDeleteUser;
